import Triangle from './Triangle';

export default Triangle;
